<script>
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * IMPORT MODULE
 *
 * This module handles data imports across the platform.
 *
 * @package Import
 */

export default {
  name: 'Import',
  data () {
    return {
      isDisabled: (setting) => {
        // if (setting.status === null) return false
        return typeof setting.value === 'boolean'
          ? !setting.value
          : setting.status !== null && !this.$user.$.companySettings[setting.status]
      },

      backUrl: (url, setting) => {
        return setting.status !== null && !setting.value || setting.status === null && setting.value === false
          ? 'javascript:;'
          : url ? url.replace('[back]', '?back-to=Imports') : ''
      },

      hasPermission: (permission) => this.$user.$.userPermissions.indexOf(permission) > -1
    }
  },

  computed: {
    settings() {
      let programsLabel = global.app.$user && global.app.$user.sessionSettings
        ? global.app.$user.sessionSettings.CompanySettings.ProgramsLabel
        : 'Programs'

      return [
        {
          name: programsLabel,
          condition: this.hasPermission('CreatePrograms'),
          status: null,
          // value: false,
          description: 'Import data to create and update ' + programsLabel.toLowerCase() + '.',
          configurable: 'Import',
          icon: ['far', 'calendar-alt'],
          url: '#/d/Import/Programs#import-file'// ,
          // endpoint: endpoints.import.programs
        },

        {
          name: 'Expenses',
          condition: this.hasPermission('CreateExpenses'),
          status: null,
          // value: false,
          description: 'Import data to create expenses.',
          configurable: 'Import',
          icon: ['fal', 'credit-card'],
          url: '#/d/Import/Expenses'// ,
          // endpoint: endpoints.import.expenses
        },

        {
          name: 'Invoices',
          condition: this.hasPermission('CreateEditPO'),
          status: null,
          // value: false,
          description: 'Import data to create invoices.',
          configurable: 'Import',
          icon: ['far', 'file-alt'],
          new: true,
          url: '#/d/Import/Invoices'// ,
          // endpoint: endpoints.import.invoices
        }/* ,

        {
          name: 'Divisions',
          status: null,
          value: false,
          description: 'Import data to create and update division configurations.',
          configurable: 'Import',
          icon: ['far', 'building'],
          url: '#/d/Import/Divisions'// ,
          // endpoint: endpoints.import.divisions
        },

        {
          name: 'Users',
          status: null,
          value: false,
          description: 'Import data to create and update user information.',
          configurable: 'Import',
          icon: ['fas', 'user'],
          url: '#/d/Import/Users'// ,
          // endpoint: endpoints.import.users
        } */
      ]
    }
  }
}
</script>

<!-- SETTINGS CARD TEMPLATE -->
<template lang="pug">
.content
  ed-title-nav(:title='$t("Import Data")')
  .container-fluid
    ed-section.active(offset=1)
      span(v-for='(setting, index) in settings')
        ed-card(
          :key='setting.name'
          :title='setting.name'
          :subtitle='setting.description.replace("[placeholder]", setting.name || setting.placeholder)'
          :footer-button='setting.configurable'
          :icon='setting.icon'
          :class='{ "new": setting.new }'
          :endpoint='setting.saving && (setting.endpoint || api.$.settings.company.$)'
          v-if='typeof setting.condition === "undefined" || setting.condition'
        )
          span(v-if='setting.help' slot='mask') {{ setting.help }}
          ed-switch(slot='top'
                    v-if='setting.status !== null'
                    :value='$user.$.companySettings[setting.status]'
                    v-model='settings[index].value'
                    @input='change(setting)'
                    @mousedown='handleEndpoint(setting)'
                    :emit-on-mount='false'
          )
          ed-input.small.inline(update-button
                                :disabled='isDisabled(setting)'
                                autofocus
                                helptipBody='You can change your division name here'
                                v-if='setting.editable'
                                v-model='setting.name'
                                @update='change(setting)'
                                @mousedown='handleEndpoint(setting)'
                                slot='title'
          )
          div(slot='footer')
            ed-button.btn.btn-actionbar-(
              :href='backUrl(setting.url, setting)'
              v-if='setting.configurable != "false"'
              :disabled='isDisabled(setting)'
              button-class='btn btn-actionbar-'
            ) {{ setting.configurable }}
</template>

<style scoped lang='scss'>
</style>



// WEBPACK FOOTER //
// src/components/_modules/Import/index.vue